import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//适配
import "../src/config/rem.js";
// import 'amfe-flexible';
//存储挂载到原型，通过this调用
import local from "./lib/local"
// this.local.set("name","wangming")
import VConsole from "vconsole";
console.log('env',process.env)
if(process.env.NODE_ENV != 'production'){
  new VConsole();
}

Vue.prototype.local = local
//vantui
import 'vant/lib/index.css';
import Vant from "vant"
import { Toast } from 'vant';
Vue.use(Vant, Toast)

Vue.config.productionTip = false;
//路由Title
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    next();
  });
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");